import { api } from "@/lib/axios";

export default function updateStatus(leadId: string, statusId: string) {
  return api.put(`deals/move/${leadId}/${statusId}`, {
    position: 0,
  });
}
